module.exports = __webpack_public_path__ + "img/Female_Anterior_Abdomen.a4f92472.png";